const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendarIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 6333"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 153534",
    style: {
      fill: "none"
    },
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 5994",
    d: "M141.816-845.408a1.753 1.753 0 0 1-1.289-.527 1.753 1.753 0 0 1-.527-1.289v-13.445a1.753 1.753 0 0 1 .527-1.289 1.753 1.753 0 0 1 1.289-.527h1.391v-2.125h1.546v2.125h7.611v-2.125h1.507v2.125h1.391a1.753 1.753 0 0 1 1.289.527 1.753 1.753 0 0 1 .527 1.289v13.445a1.753 1.753 0 0 1-.527 1.289 1.753 1.753 0 0 1-1.289.527zm0-1.507h13.445a.3.3 0 0 0 .212-.1.3.3 0 0 0 .1-.213v-9.427h-14.066v9.427a.3.3 0 0 0 .1.213.3.3 0 0 0 .209.1zm-.309-11.243h14.064v-2.511a.3.3 0 0 0-.1-.212.3.3 0 0 0-.212-.1h-13.443a.3.3 0 0 0-.212.1.3.3 0 0 0-.1.212zm0 0z",
    transform: "translate(-136.539 867.009)",
    style: {
      fill: "#707070"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendar_icon.b3f64414699b95fe2f261b79265fa573.svg";
export { ForwardRef as ReactComponent };